import NdaStatusProofFiles from './NdaStatusProofFiles.component';

export default NdaStatusProofFiles;